import React, { useRef } from "react";
import img1 from "../assets/images/pillar1.png";
import img2 from "../assets/images/pillar2.png";
import img7 from "../assets/images/pillar3.png";
import "../assets/style/parallaxScroll.scss";
import { motion, useScroll, useTransform } from "framer-motion";


const WhatWeDonew = () => {
  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["center 80%", "end 20%"],
  });

  const getTransformValues = (screenWidth) => {
    if (screenWidth <= 480) {
      return {
        center: [0, -50],
        topLeft: [0, -100],
        topRight: [0, -150],
        bottomRight: [0, -200],
        bottomLeft: [0, -250],
      };
    } else if (screenWidth <= 768) {
      return {
        center: [0, -100],
        topLeft: [0, -150],
        topRight: [0, -200],
        bottomRight: [0, -250],
        bottomLeft: [0, -300],
      };
    } else {
      return {
        center: [0, -150],
        topLeft: [0, -200],
        topRight: [0, -250],
        bottomRight: [0, -300],
        bottomLeft: [0, -350],
      };
    }
  };

  const transformValues = getTransformValues(window.innerWidth);

  const centerTransform = useTransform(
    scrollYProgress,
    [0, 0.5],
    transformValues.center
  );
  const topLeftTransform = useTransform(
    scrollYProgress,
    [0, 0.5],
    transformValues.topLeft
  );
  const bottomLeftTransform = useTransform(
    scrollYProgress,
    [0, 0.5],
    transformValues.bottomLeft
  );

  const headings = [
    "DEEP TECH",
    "GLOBAL CAPITAL & REAL ASSETS",
    "FUTURE LIFESTYLE & SUSTAINABILITY",
  ];

  const images = [
    { src: img1, y: bottomLeftTransform },
    { src: img2, y: topLeftTransform },
    { src: img7, y: centerTransform },
  ];

  return (
    <div className="mx-auto  text-center relative">
      <div className="flex flex-col items-center pt-[100px] z-10">
        <h4 className=" text-2xl md:text-4xl lg:text-5xl font-normal mb-4">
          PILLARS OF THE FUTURE
        </h4>
      </div>

      <div ref={containerRef} className="container1">
        <div className="mobile_image p-4">
          {images.map(({ src, y }, index) => (
            <div key={index} className="pt-8">
              <img src={src} alt="" />
              <h3 className="text-left text-lg py-2">{headings[index]}</h3>
            </div>
          ))}
        </div>

        <div className="images">
          {images.map(({ src, y }, index) => (
            <motion.div
              key={`image_${index}`}
              style={{ y }}
              className={`imageContainer position-${index + 1}`}
            >
              <img src={src} alt="" />
              <h3 className="text-left text-lg py-2">{headings[index]}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatWeDonew;
